export const BASE_URL = (process.env.REACT_APP_API_URL || 'https://api.safzi.com/api/v1').replace(/\/$/, '');

const getHeaders = () => {
  const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    let errorMessage = data.message || 'Something went wrong';

    // Enhance generic "Validation failed" with specific details if available
    if (data.errors && typeof data.errors === 'object' && Object.keys(data.errors).length > 0) {
      const firstField = Object.keys(data.errors)[0];
      const firstError = Array.isArray(data.errors[firstField]) 
        ? data.errors[firstField][0] 
        : data.errors[firstField];
      
      // Only use the specific error if it's a string (ignore numeric metadata like remaining_attempts)
      if (typeof firstError === 'string') {
        errorMessage = firstError;
      }
    }

    const error = {
      status: response.status,
      message: errorMessage,
      errors: data.errors || null,
      data: data.data || null
    };
    throw error;
  }
  return data;
};

export const api = {
  get: async (endpoint) => {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'GET',
      headers: getHeaders(),
    });
    return handleResponse(response);
  },

  post: async (endpoint, body) => {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(body),
    });
    return handleResponse(response);
  },

  // Specialized for FormData (receipts/KYC)
  postFile: async (endpoint, formData) => {
    const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
    const headers = {
      'Accept': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: headers,
      body: formData,
    });
    return handleResponse(response);
  },

  put: async (endpoint, body) => {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(body),
    });
    return handleResponse(response);
  },

  delete: async (endpoint) => {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'DELETE',
      headers: getHeaders(),
    });
    return handleResponse(response);
  },
};
